<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm"
      class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="flex flex-col justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-0-100">
      <mat-label>Name</mat-label>
      <input matInput formControlName="text" required
             particleAnalytics
             analyticsCategory="add-text"
             analyticsAction="link-text">
      <mat-error *ngIf="inputFormError.text.required">
        Please type a link-text.
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="flex-1-0-100">
      <mat-label>Link</mat-label>
      <input matInput formControlName="link" required
             particleAnalytics
             analyticsCategory="add-link"
             analyticsAction="link-url">
      <mat-error *ngIf="inputFormError.link">
        It must be a link
      </mat-error>
    </mat-form-field>

  </div>
</form>
